import axios from "axios";

export default {
    uploadDocument(_, params) {
        params.body['file_name'] = params.document.name;
        const form = new FormData();
        form.append('body', JSON.stringify(params.body));
        form.append('document', params.document);

        return axios.post(`/api/documents/upload-document`, form, {withCredentials: true});
    },
    
    updateDocument(_, params) {
        return axios.patch(`/api/documents/update-document/${params.id}`, params, {withCredentials: true});
    },
    
    updateDocumentRelation(_, params) {
        return axios.patch(`/api/documents/update-document-relation/${params.key}/${params.id}`, params, {withCredentials: true});
    },
    
    deleteDocument(_, params) {
        return axios.delete(`/api/documents/delete-document/${params.action}/${params.id}`, {withCredentials: true});
    },
    
    getDirectories(_) {
        return axios.get(`/api/documents/get-directories`, {withCredentials: true});
    },
    
    getDocuments(_, params) {
        return axios.get(`/api/documents/get-documents/${params.key}/${params.value}/${params.category}`, {withCredentials: true});
    },
    
    viewDocument(_, id) {
        window.open(`${process.env.VUE_APP_API_ENDPOINT}/api/documents/view-document/${id}`);
    },
    
    getOtherRelations(_, id) {
        return axios.get(`/api/documents/get-other-relations/${id}`, {withCredentials: true});
    },
}